import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class PersonEffects {


  constructor(private actions$: Actions) {}
}
